//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { reduceToRecord } from '@utils/reduceToRecord';

/**
 * Reduce an array of items into individual groups based on some unique property
 * @param items Array of items to reduce
 * @param map Function that maps the item to a value that the object can be indexed by.
 */
export function groupBy<T>(
  items: T[],
  indexSelector: (item: T) => boolean,
): { true: T[], false: T[] };
export function groupBy<T, U extends PropertyKey>(
  items: T[],
  indexSelector: (item: T) => U,
): Record<U, T[]>;
export function groupBy<T, U extends PropertyKey>(
  items: T[],
  indexSelector: (item: T) => U,
): Record<U, T[]> {
  const acc = {} as Record<U, T[]>;
  items.forEach((item) => {
    const key = indexSelector(item);
    const prev = acc[key] ?? [];
    acc[key] = [...prev, item];
  });
  return acc;
}
